module.exports = __webpack_public_path__ + "fonts/nucleo-icons.ttf!static";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/nucleo-icons.ttf
// module id = 111
// module chunks = 0